// Registro seguro para evitar DOMException por doble definición
export function safeDefine(tag: string, Ctor: CustomElementConstructor) {
  if (!customElements.get(tag)) customElements.define(tag, Ctor);
}
